export { default } from './FileUpload';


// WEBPACK FOOTER //
// ./src/components/shared/FileUpload/index.ts